import NavigationBar from './components/NavigationBar';
import Translate from './pages/Translate';
import Login from './pages/Login';
import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import Toastify from './components/Toastify';

import LoadingOverlay from './components/LoadingOverlay';
import { useFirebaseText } from './hooks/useFirebaseText';
import { useSyncAuth0AccessToken } from './hooks/useSyncAuth0AccessToken';
import { useAppInitialization } from './hooks/useAppInitialization';

const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

const App = () => {

	const { isAuthenticated, isLoading } = useAuth0();
	const { isTokenLoading } = useSyncAuth0AccessToken(clientId);
	const { isAppInitialized } = useAppInitialization(clientId);
	useFirebaseText();

	if (isLoading || isTokenLoading) {
		return <></>
	}

	return isAuthenticated ? (
			<div>
				{!isAppInitialized ? <LoadingOverlay /> : (
					<div className="app">
						<NavigationBar />
						<Translate />
					</div>)
				}
			</div>
		) :
		(
			<>
				<Toastify />
				<Login />
			</>
		);
};

export default App;

